import React, { useState, useEffect } from "react";

interface CollectionSelectorProps {
  onSelectCollection: (collection: string) => void;
  selectedCollection: string;
  role?: string;
  compact?: boolean;
}

const CollectionSelector: React.FC<CollectionSelectorProps> = ({ onSelectCollection, selectedCollection, role, compact = false }) => {
  const [collections, setCollections] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);
    setError("");
    const availableCollections = role === "admin" ? ["bikeFrames", "users"] : ["bikeFrames"];
    setCollections(availableCollections);
    if (!availableCollections.includes(selectedCollection)) {
      const nextCollection = availableCollections[0];
      onSelectCollection(nextCollection);
    }
    setLoading(false);
  }, [role, onSelectCollection, selectedCollection]);

  if (loading) return <div style={{ color: "#64ffda", fontSize: compact ? "14px" : "18px", textAlign: "center", padding: compact ? "0" : "20px" }}>Ładowanie kolekcji...</div>;
  if (error) return <div style={{ color: "#ff6b6b", fontSize: compact ? "14px" : "18px", textAlign: "center", padding: compact ? "0" : "20px" }}>{error}</div>;
  if (collections.length === 0) return <div style={{ color: "#8892b0", fontSize: compact ? "14px" : "18px", textAlign: "center", padding: compact ? "0" : "20px" }}>Brak kolekcji do wyboru</div>;

  const handleSelectCollection = (collection: string) => {
    onSelectCollection(collection);
  };

  return (
    <div style={{ marginBottom: compact ? "0" : "30px", width: compact ? "auto" : "100%" }}>
      {!compact && <h3 style={{ color: "#ccd6f6", marginBottom: "15px", fontSize: "20px" }}>Wybierz kolekcję:</h3>}
      <div style={{
        display: "flex",
        gap: "12px",
        flexWrap: "wrap",
        justifyContent: compact ? "flex-end" : "flex-start",
        alignItems: "center"
      }}>
        {collections.map(collection => (
          <button
            key={collection}
            onClick={() => handleSelectCollection(collection)}
            style={{
              padding: compact ? "8px 14px" : "10px 20px",
              backgroundColor: selectedCollection === collection ? "#64ffda" : "#1e2d45",
              color: selectedCollection === collection ? "#0a192f" : "#ccd6f6",
              border: "1px solid #3a506b",
              borderRadius: "6px",
              cursor: "pointer",
              fontWeight: selectedCollection === collection ? "bold" : "normal",
              transition: "all 0.3s ease",
              marginBottom: "0"
            }}
          >
            {collection}
          </button>
        ))}
      </div>
    </div>
  );
};

export default CollectionSelector;
